import {toggleMark} from "prosemirror-commands";
import {schema} from "../../config/schema";

export const toggleMarkBold = toggleMark(schema.marks.bold)
